import React from 'react';
import { useLocation } from 'react-router-dom';
import { estEnPreview, trouverNumeroDePage } from '../../lib/pageRegistry';

/**
 * La pastille qui affiche le numéro de la page courante, en bas à gauche.
 *
 * Demande d'Emeni (2026-08-28) : pouvoir dire « la page 46 » au lieu de décrire un écran. Elle est montée
 * UNE SEULE FOIS, au niveau de l'application : rien à poser page par page, et une page ajoutée demain
 * l'affiche sans qu'on y pense — à condition d'être inscrite au registre.
 *
 * JAMAIS EN PRODUCTION. `estEnPreview()` compare le domaine à la liste des domaines de production ; le
 * composant ne rend rien ailleurs. Un client ne doit pas voir ces numéros, qui n'ont de sens qu'entre nous.
 *
 * Discrète mais lisible : semi-transparente au repos, pleinement visible au survol, et elle ne capture
 * jamais le clic (`pointer-events-none`) pour ne pas gêner un bouton placé dessous.
 */
export const PageNumberBadge: React.FC = () => {
    const { pathname } = useLocation();

    if (!estEnPreview()) return null;

    const page = trouverNumeroDePage(pathname);

    return (
        <div
            className="fixed bottom-2 left-2 z-[9999] pointer-events-none select-none"
            aria-hidden="true"
        >
            {page ? (
                <div className="flex items-center gap-1.5 rounded-lg bg-black/70 px-2 py-1 font-mono text-[11px] text-white/90 opacity-60 shadow-lg backdrop-blur-sm transition-opacity hover:opacity-100">
                    <span className="font-black text-amber-300">p.{page.numero}</span>
                    <span className="max-w-[220px] truncate text-white/70">{page.libelle}</span>
                </div>
            ) : (
                // Une page non répertoriée est un oubli, pas un cas normal : on le dit, plutôt que de
                // n'afficher rien du tout et de laisser croire que la numérotation est complète.
                <div className="rounded-lg bg-red-600/80 px-2 py-1 font-mono text-[11px] text-white shadow-lg">
                    page sans numéro — à ajouter au registre
                </div>
            )}
        </div>
    );
};
